/**
 * LTI Enroll Exam
 * LTI Enroll Exam for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';

/**
* EventDetail service.
* @module api/EventDetailApi
* @version 2.0.0
*/
export default class EventDetailApi {

    /**
    * Constructs a new EventDetailApi. 
    * @alias module:api/EventDetailApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get exam Buildings
     * @param {Number} examConvocation 
     * @param {Number} studentId 
     * @param {Number} formativeActionId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    enrollExamControllerExamBuildingsWithHttpInfo(examConvocation, studentId, formativeActionId) {
      let postBody = null;
      // verify the required parameter 'examConvocation' is set
      if (examConvocation === undefined || examConvocation === null) {
        throw new Error("Missing the required parameter 'examConvocation' when calling enrollExamControllerExamBuildings");
      }
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollExamControllerExamBuildings");
      }
      // verify the required parameter 'formativeActionId' is set
      if (formativeActionId === undefined || formativeActionId === null) {
        throw new Error("Missing the required parameter 'formativeActionId' when calling enrollExamControllerExamBuildings");
      }

      let pathParams = {
        'exam_convocation': examConvocation,
        'student_id': studentId,
        'formative_action_id': formativeActionId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/lti/enrollExam/exam_buildings/exam_convocation/{exam_convocation}/student/{student_id}/formative_action/{formative_action_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get exam Buildings
     * @param {Number} examConvocation 
     * @param {Number} studentId 
     * @param {Number} formativeActionId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    enrollExamControllerExamBuildings(examConvocation, studentId, formativeActionId) {
      return this.enrollExamControllerExamBuildingsWithHttpInfo(examConvocation, studentId, formativeActionId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get shedules exam
     * @param {String} studentId 
     * @param {Number} examConvocationId 
     * @param {Number} buildingId 
     * @param {Number} formativeActionId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    enrollExamControllerGetShedulesExamWithHttpInfo(studentId, examConvocationId, buildingId, formativeActionId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollExamControllerGetShedulesExam");
      }
      // verify the required parameter 'examConvocationId' is set
      if (examConvocationId === undefined || examConvocationId === null) {
        throw new Error("Missing the required parameter 'examConvocationId' when calling enrollExamControllerGetShedulesExam");
      }
      // verify the required parameter 'buildingId' is set
      if (buildingId === undefined || buildingId === null) {
        throw new Error("Missing the required parameter 'buildingId' when calling enrollExamControllerGetShedulesExam");
      }
      // verify the required parameter 'formativeActionId' is set
      if (formativeActionId === undefined || formativeActionId === null) {
        throw new Error("Missing the required parameter 'formativeActionId' when calling enrollExamControllerGetShedulesExam");
      }

      let pathParams = {
        'student_id': studentId,
        'exam_convocation_id': examConvocationId,
        'building_id': buildingId,
        'formative_action_id': formativeActionId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/lti/enrollExam/shedules/student/{student_id}/building/{building_id}/exam_convocation/{exam_convocation_id}/formative_action/{formative_action_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get shedules exam
     * @param {String} studentId 
     * @param {Number} examConvocationId 
     * @param {Number} buildingId 
     * @param {Number} formativeActionId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    enrollExamControllerGetShedulesExam(studentId, examConvocationId, buildingId, formativeActionId) {
      return this.enrollExamControllerGetShedulesExamWithHttpInfo(studentId, examConvocationId, buildingId, formativeActionId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
